module.exports = __webpack_public_path__ + "img/ai.1024660a.svg";